import { render, staticRenderFns } from "./ProfileCardPopup.vue?vue&type=template&id=6baed954&scoped=true&"
import script from "./ProfileCardPopup.vue?vue&type=script&lang=js&"
export * from "./ProfileCardPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCardPopup.vue?vue&type=style&index=0&id=6baed954&scoped=true&lang=css&"
import style1 from "./ProfileCardPopup.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baed954",
  null
  
)

export default component.exports